<script>
export default {
    data() {
        return {
            dataObj: {}
        }
    }
}
</script>